// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawflow-log-dialog[data-v-7fda2300]{background:#fff}.logs-dialog-card[data-v-7fda2300]{background-color:#fff!important;opacity:1!important}.logs-dialog-title[data-v-7fda2300]{background-color:#f5f5f5}.logs-dialog-content[data-v-7fda2300]{max-height:70vh;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
